import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { isNil, cloneDeep } from 'lodash-es';
import { ToastrService } from 'ngx-toastr';

import { WavelengthShellService } from 'wavelength-ui';
import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


import { CleanupLoggerService } from './cleanup.logging.service';
import { Totes_tote_induction_formComponent } from './Totes.tote_induction_form.component';
import { Totes_tote_picking_formComponent } from './Totes.tote_picking_form.component';
import { Totes_totes_homeComponent } from './Totes.totes_home.component';
import { Totes_tote_container_statuses_gridComponent } from './Totes.tote_container_statuses_grid.component';
import { Totes_tote_containers_gridComponent } from './Totes.tote_containers_grid.component';
import { Totes_tote_types_gridComponent } from './Totes.tote_types_grid.component';
import { Totes_totes_hubComponent } from './Totes.totes_hub.component';
import { Totes_tote_container_statuses_dd_singleComponent } from './Totes.tote_container_statuses_dd_single.component';
import { Totes_tote_container_types_dd_singleComponent } from './Totes.tote_container_types_dd_single.component';
import { Totes_warehouses_dd_singleComponent } from './Totes.warehouses_dd_single.component';
import { Totes_tote_container_statuses_dd_multiComponent } from './Totes.tote_container_statuses_dd_multi.component';
import { Totes_tote_container_types_dd_multiComponent } from './Totes.tote_container_types_dd_multi.component';
import { Totes_warehouses_dd_multiComponent } from './Totes.warehouses_dd_multi.component';

import { Utilities_ShellService } from './Utilities.shell.service';

@Injectable({ providedIn: 'root' })
export class Totes_ShellService extends WavelengthShellService  {
  constructor(
    dialog : MatDialog,
    toastr: ToastrService,
    private $logger: CleanupLoggerService,
    public Utilities: Utilities_ShellService,
  ) {
    super(dialog, toastr);
  }

  public Totes: Totes_ShellService = this;

  public opentote_induction_form(replaceCurrentView?: boolean) {
    this.$logger.log('Totes', 'tote_induction_form');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Tote induction',
        referenceName: 'Totes_tote_induction_form',
        component: Totes_tote_induction_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opentote_induction_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('Totes', 'tote_induction_form');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      Totes_tote_induction_formComponent,
      'Tote induction',
      mode,
      dialogSize
    )
  }
  public opentote_picking_form(replaceCurrentView?: boolean) {
    this.$logger.log('Totes', 'tote_picking_form');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Tote picking',
        referenceName: 'Totes_tote_picking_form',
        component: Totes_tote_picking_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opentote_picking_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('Totes', 'tote_picking_form');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      Totes_tote_picking_formComponent,
      'Tote picking',
      mode,
      dialogSize
    )
  }
  public opentotes_home(replaceCurrentView?: boolean) {
    this.$logger.log('Totes', 'totes_home');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Totes home page',
        referenceName: 'Totes_totes_home',
        component: Totes_totes_homeComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opentotes_homeDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('Totes', 'totes_home');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      Totes_totes_homeComponent,
      'Totes home page',
      mode,
      dialogSize
    )
  }
  public opentote_container_statuses_grid(replaceCurrentView?: boolean) {
    this.$logger.log('Totes', 'tote_container_statuses_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Tote container statuses',
        referenceName: 'Totes_tote_container_statuses_grid',
        component: Totes_tote_container_statuses_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opentote_container_statuses_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('Totes', 'tote_container_statuses_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      Totes_tote_container_statuses_gridComponent,
      'Tote container statuses',
      mode,
      dialogSize
    )
  }
  public opentote_containers_grid(replaceCurrentView?: boolean) {
    this.$logger.log('Totes', 'tote_containers_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Tote containers',
        referenceName: 'Totes_tote_containers_grid',
        component: Totes_tote_containers_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opentote_containers_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('Totes', 'tote_containers_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      Totes_tote_containers_gridComponent,
      'Tote containers',
      mode,
      dialogSize
    )
  }
  public opentote_types_grid(replaceCurrentView?: boolean) {
    this.$logger.log('Totes', 'tote_types_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Tote types',
        referenceName: 'Totes_tote_types_grid',
        component: Totes_tote_types_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opentote_types_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('Totes', 'tote_types_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      Totes_tote_types_gridComponent,
      'Tote types',
      mode,
      dialogSize
    )
  }
  public opentotes_hub(replaceCurrentView?: boolean) {
    this.$logger.log('Totes', 'totes_hub');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Totes',
        referenceName: 'Totes_totes_hub',
        component: Totes_totes_hubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opentotes_hubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('Totes', 'totes_hub');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      Totes_totes_hubComponent,
      'Totes',
      mode,
      dialogSize
    )
  }

  public override getComponentInformation(referenceName: string, params: ParamMap): { title: string, component: any, inParams: any } {
    if (referenceName === 'Totes_tote_induction_form') {
      this.$logger.log('Totes', 'tote_induction_form');
      const title = 'Tote induction';
      const component = Totes_tote_induction_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'Totes_tote_picking_form') {
      this.$logger.log('Totes', 'tote_picking_form');
      const title = 'Tote picking';
      const component = Totes_tote_picking_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'Totes_totes_home') {
      this.$logger.log('Totes', 'totes_home');
      const title = 'Totes home page';
      const component = Totes_totes_homeComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'Totes_tote_container_statuses_grid') {
      this.$logger.log('Totes', 'tote_container_statuses_grid');
      const title = 'Tote container statuses';
      const component = Totes_tote_container_statuses_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'Totes_tote_containers_grid') {
      this.$logger.log('Totes', 'tote_containers_grid');
      const title = 'Tote containers';
      const component = Totes_tote_containers_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'Totes_tote_types_grid') {
      this.$logger.log('Totes', 'tote_types_grid');
      const title = 'Tote types';
      const component = Totes_tote_types_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'Totes_totes_hub') {
      this.$logger.log('Totes', 'totes_hub');
      const title = 'Totes';
      const component = Totes_totes_hubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'Totes_tote_container_statuses_dd_single') {
      this.$logger.log('Totes', 'tote_container_statuses_dd_single');
      const title = 'tote_container_statuses_dd';
      const component = Totes_tote_container_statuses_dd_singleComponent;
      const inParams:{ fullTextSearch?: string } = { fullTextSearch: null };
      if (!isNil(params.get('fullTextSearch'))) {
        const paramValueString = params.get('fullTextSearch');
        // TODO: date
        inParams.fullTextSearch = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'Totes_tote_container_types_dd_single') {
      this.$logger.log('Totes', 'tote_container_types_dd_single');
      const title = 'tote_container_types_dd';
      const component = Totes_tote_container_types_dd_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'Totes_warehouses_dd_single') {
      this.$logger.log('Totes', 'warehouses_dd_single');
      const title = 'Warehouses Dropdown';
      const component = Totes_warehouses_dd_singleComponent;
      const inParams:{ warehouseId?: number } = { warehouseId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'Totes_tote_container_statuses_dd_multi') {
      this.$logger.log('Totes', 'tote_container_statuses_dd_multi');
      const title = 'tote_container_statuses_dd';
      const component = Totes_tote_container_statuses_dd_multiComponent;
      const inParams:{ fullTextSearch?: string } = { fullTextSearch: null };
      if (!isNil(params.get('fullTextSearch'))) {
        const paramValueString = params.get('fullTextSearch');
        // TODO: date
        inParams.fullTextSearch = paramValueString;
              }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'Totes_tote_container_types_dd_multi') {
      this.$logger.log('Totes', 'tote_container_types_dd_multi');
      const title = 'tote_container_types_dd';
      const component = Totes_tote_container_types_dd_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'Totes_warehouses_dd_multi') {
      this.$logger.log('Totes', 'warehouses_dd_multi');
      const title = 'Warehouses Dropdown';
      const component = Totes_warehouses_dd_multiComponent;
      const inParams:{ warehouseId?: number } = { warehouseId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }


    let result = null;
    result = this.Utilities.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    return result;
  }
}
